<template>
    <div class="artile">
        <div class="model-box">
            <div class="news-info-item">
                <span class="title">封面</span>
                <!--<uploadMoulde style="margin-left: 27px;display: inline-block;margin-top: 20px;margin-bottom: 20px" :value="newsData.coverUrl"-->
                <!--:limitNumber="1" v-on:input="getSucessInfo" ref="childUpload"></uploadMoulde>-->
                <!-- 剪裁组件弹窗 -->
                <cropper style="margin-left: 27px;display: inline-block;margin-top: 20px;margin-bottom: 20px"
                         :value="newsData.coverUrl" v-on:input="getSucessInfo" ref="childUpload"></cropper>
            </div>
        </div>

        <div class="news-info-box">
            <div class="news-info-item">
                <span class="title">语言</span>
                <el-select :value="newsData.lang" @change="handleQueryChange('language', $event)" placeholder="请选择">
                    <el-option v-for="item in languageList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="news-info-item">
                <span class="title">标题</span>
                <el-input type="text" placeholder="请输入标题" v-model="newsData.newsTitle" maxlength="100" show-word-limit
                          style="width: 90%;border: 0px"></el-input>
            </div>
            <div class="news-info-item">
                <span class="title">副标题</span>
                <el-input type="text" placeholder="请输入摘要/副标题（非必填）" v-model="newsData.newsSubtitle" maxlength="100"
                          show-word-limit
                          style="width: 90%;border: 0px"></el-input>
            </div>
            <div class="news-info-item">
                <span class="title">作者</span>
                <el-input type="text" placeholder="请输入作者姓名（非必填）" v-model="newsData.authorName" maxlength="20"
                          show-word-limit
                          style="width: 90%;border: 0px"></el-input>
            </div>
            <div class="news-info-item">
                <span class="title">栏目</span>
                <el-cascader :options="options" v-model="columnObj"
                             @change="handleItemChange"
                             :change-on-select="true" clearable></el-cascader>
            </div>
            <div class="news-info-item">
                <span class="title">级别</span>
                <el-select v-model="newsData.grade" placeholder="请选择">
                    <el-option v-for="item in gradeList" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="news-info-item">
                <span class="title">标签</span>
                <div style="margin-top: 15px">
                    <el-tag :key="tag.id" v-for="tag in dynamicTagsObj" closable :disable-transitions="false"
                            @close="handleClose(tag)" style="margin-right: 20px;margin-bottom: 20px">
                        {{tag.labelName}}
                    </el-tag>
                    <el-button class="button-new-tag" size="small" @click="openChooseLabelDialog">+ 选择标签
                    </el-button>
                </div>
            </div>
            <div class="news-info-item">
                <span class="title">推荐</span>
                <el-switch style="margin-left: 20px" v-model="recommend"
                           active-color="#EC6D56"></el-switch>
            </div>
            <div class="news-info-item">
                <span class="title">置顶</span>
                <el-switch style="margin-left: 20px" v-model="topping"
                           active-color="#EC6D56"></el-switch>
            </div>
            <div class="news-info-item">
                <span class="title">定时发布</span>
                <el-switch style="margin-left: 20px" v-model="timing"
                           active-color="#EC6D56"></el-switch>
                <el-date-picker :disabled="!timing" style="width: 200px;margin-left: 20px"
                                v-model="newsData.publishTime"
                                type="datetime" value-format="timestamp" placeholder="定时发布时间">
                </el-date-picker>
            </div>
            <div class="news-info-item">
                <span class="title">交易对</span>
                <span style="color: gainsboro;padding-left: 20px" v-if="tradePair.length<=0">暂无选择</span>
                <el-tag :key="pair" v-for="pair in tradePair" closable :disable-transitions="false"
                        @close="handlePairClose(pair)" style="margin-right: 10px;margin-bottom: 5px">
                    {{pair}}
                </el-tag>
            </div>
            <div class="news-info-item">
                <span class="title">已上传的图片</span>
                <span style="color: gainsboro;padding-left: 20px" v-if="imageUrls.length<=0">暂未上传</span>
                <el-tag :key="img" v-for="img in imageUrls" closable :disable-transitions="false"
                        @close="handleImgClose(img)"
                        style="margin-right: 30px;margin-bottom:5px;padding:0 0;width: 50px;height: 50px">
                    <img :src="img" style="width: 50px;height: 50px"/>
                </el-tag>
            </div>
            <div class="news-info-item" style="border: 0px">
                <span class="title">正文</span>
                <el-tag type="danger" @click.native="openProductDialog('PERIODICAL')"
                        style="color:#EC6D56;font-size:14px;font-family:Microsoft YaHei;float: right;margin-left: 20px;cursor: pointer">
                    定期宝
                </el-tag>
                <el-tag type="danger" @click.native="openProductDialog('CURRENT')"
                        style="color:#EC6D56;font-size:14px;font-family:Microsoft YaHei;float: right;margin-left: 20px;cursor: pointer">
                    活期宝
                </el-tag>
                <el-tag type="danger" @click.native="newsDialogVisible = true"
                        style="color:#EC6D56;font-size:14px;font-family:Microsoft YaHei;float: right;margin-left: 20px;cursor: pointer">
                    文章
                </el-tag>
                <el-tag type="danger" @click.native="openPairDialog()"
                        style="color:#EC6D56;font-size:14px;font-family:Microsoft YaHei;float: right;margin-left: 20px;cursor: pointer">
                    交易对
                </el-tag>
                <el-tag type="danger" @click.native="quotationDialog"
                        style="color:#EC6D56;font-size:14px;font-family:Microsoft YaHei;float: right;margin-left: 20px;cursor: pointer">
                    行情
                </el-tag>
                <el-popover @show="qrCode"
                            placement="top-start"
                            width="150"
                            trigger="hover">
                    <div id="qrcode"></div>
                    <el-tag type="danger" slot="reference"
                            style="color:#EC6D56;font-size:14px;font-family:Microsoft YaHei;float: right;margin-left: 20px;cursor: pointer">
                        手机预览
                    </el-tag>
                </el-popover>
                <el-tag type="danger" @click.native="connectSocket"
                        style="color:#EC6D56;font-size:14px;font-family:Microsoft YaHei;float: right;margin-left: 20px;cursor: pointer">
                    连接socket
                </el-tag>
                <div style="width: 1400px;margin-top: 40px;">
                    <el-ueditor :value="newsData.richText" @change="handleFormChangeContent" ref="uediter"
                                style="width: 676px;display: inline-block"></el-ueditor>
                    <div class="left-detail-box">
                        <div class="content-box" style="width: 100%;height: 100%">
                            <div class="title" v-if="newsData.newsTitle!=''">{{newsData.newsTitle}}</div>
                            <div class="author" v-if="newsData.authorName!=''">
                                作者：{{newsData.authorName}}
                            </div>
                            <div class="time" v-if="newsData.createTime!=''">
                                {{newsData.createTime | moment}}
                            </div>
                            <div class="content">
                                <div class="abstract" v-if="newsData.newsSubtitle!=''">
                                    {{newsData.newsSubtitle}}
                                </div>
                                <div class="detail" v-html="newsData.richText"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="news-info-buttom">
                <el-button type="danger" @click="saveNews">发 布</el-button>
            </div>
        </div>

        <!--插入行情弹框-->
        <el-dialog title="插入行情" :visible.sync="quotationDialogVisible" width="60%" @close="clearDataThree">
            <div class="news-info-item">
                <span class="title">交易对</span>
                <el-select placeholder="请选择" v-model="quotationData.pair" filterable
                           style="width: 60%;margin-left: 18px" size="small">
                    <el-option v-for="(item,index) in pairOptions"
                               :key="item.exchangeCoin+'_'+item.anchoredCoin+'_'+index"
                               :label="item.exchangeCoin+'/'+item.anchoredCoin"
                               :value="item.exchangeCoin+'_'+item.anchoredCoin">
                    </el-option>
                </el-select>
            </div>

            <div class="news-info-item">
                <span class="title">封  面</span>
                <uploadMoulde style="margin-left: 27px;display: inline-block;margin-top: 20px;margin-bottom: 20px"
                              :limitNumber="1"
                              v-on:input="getQuotationSucessInfo" ref="quotationUpload"></uploadMoulde>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="insertCard('QUOTATIONCARD')">确 定</el-button>
            </span>
        </el-dialog>

        <!--插入交易对弹框-->
        <el-dialog title="插入交易对" :visible.sync="pairDialogVisible" width="400px" @close="clearDataTwo">
            <el-select placeholder="请选择" v-model="pair" filterable
                       style="width: 90%" size="small">
                <el-option v-for="(item,index) in pairOptions" :key="item.exchangeCoin+'_'+item.anchoredCoin+'_'+index"
                           :label="item.exchangeCoin+'/'+item.anchoredCoin"
                           :value="item.exchangeCoin+'_'+item.anchoredCoin">
                </el-option>
            </el-select>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="insertCard('PAIRCARD')">确 定</el-button>
            </span>
        </el-dialog>

        <!--插入新闻弹框-->
        <el-dialog title="插入文章" :visible.sync="newsDialogVisible" width="60%" @close="clearData">
            <div class="news-info-item">
                <span class="title">封面</span>
                <uploadMoulde style="margin-left: 27px;display: inline-block;margin-top: 20px;margin-bottom: 20px"
                              :limitNumber="1"
                              v-on:input="getArticleSucessInfo" ref="articleUpload"></uploadMoulde>
            </div>
            <div class="news-info-item">
                <span class="title">标题</span>
                <el-input type="text" placeholder="请输入标题" v-model="articleData.title" maxlength="100" show-word-limit
                          style="width: 90%;border: 0px"></el-input>
            </div>
            <div class="news-info-item">
                <span class="title">作者</span>
                <el-input type="text" placeholder="请输入作者" v-model="articleData.auther" maxlength="20" show-word-limit
                          style="width: 90%;border: 0px"></el-input>
            </div>
            <div class="news-info-item">
                <span class="title">地址</span>
                <el-input type="text" placeholder="请输入文章链接" v-model="articleData.url" show-word-limit
                          style="width: 90%;border: 0px"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="insertCard('ARTICLECARD')">确 定</el-button>
            </span>
        </el-dialog>

        <!--插入产品弹框-->
        <el-dialog :title="productDialogTitle" :visible.sync="productDialogVisible" width="400px" @close="clearDataTwo">
            <el-select placeholder="请选择" v-model="productId" filterable
                       style="width: 90%" size="small">
                <el-option v-for="item in productOptions" :key="item.id" :label="item.title" :value="item.id">
                </el-option>
            </el-select>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="insertCard('PRODUCT')">确 定</el-button>
            </span>
        </el-dialog>

        <!--标签弹框-->
        <el-dialog title="选择标签" :visible.sync="dialogVisible" width="40%">
            <div>
                <div>
                    <el-tabs v-model="activeName" @tab-click="handleLabelClick"
                             style="width: 80%;display: inline-block">
                        <el-tab-pane v-for="item in labelArry" :key="item.value" :label="item.label" :name="item.value"></el-tab-pane>
                    </el-tabs>
                </div>
                <div style="margin-top: 20px">
                    <el-input placeholder="请输入名称" v-model="queryLabel.labelName" prefix-icon="el-icon-search"
                              style="width: 80%"></el-input>
                    <el-button style="margin-left: 10px" type="danger" @click="searchDialogLabel">搜索</el-button>
                </div>
                <div style="margin-top: 20px;margin-bottom: 50px;max-height: 400px">
                    <el-tag style="margin-right: 5px;cursor: default;margin-bottom: 5px" v-for="item in labelListDialog"
                            :key="item.id"
                            @click.native="chooseLabel(item)" :type="getTagType(item.id)">
                        {{item.labelName}}
                    </el-tag>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="dialogVisible=false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';
    import {mapMutations, mapState} from 'vuex';
    import elUeditor from './editor/elUeditor';
    import uploadMoulde from "../../../components/upload/indexLimit.vue";
    import userInfoHelper from '../../../common/userInfo';
    import cropper from '../../../components/cropImage/index.vue';
    import {NEWSGRADE,LABELTYPE} from "../common/constants";
    import {WSPREVIEW, HTTPPREVIEW} from "../common/wsAddress";
    import moment from 'moment';
    import QRCode from 'qrcodejs2'

    export default {
        name: "ArticleSimplify",
        components: {elUeditor, uploadMoulde, cropper},
        data() {
            return {
                gradeList: NEWSGRADE,
                newsData: { //文章数据
                    modelType: 1,
                    newsTitle: "",
                    newsSubtitle: "",
                    authorName: "",
                    coverUrl: "",
                    richText: "",
                    lang: "zh",
                    newsType: "ARTICLE",
                    newsId: "",
                    labelIds: "",
                    columnId: "",
                    columnIds: "",
                    recommend: "NO",
                    topping: "NO",
                    imageUrls: "",
                    tradePair: "",
                    grade: "ONE",
                    timer: "NO",
                    publishTime: "",
                    userName: userInfoHelper.get().userName
                },
                pair: "", //交易对
                pairDialogVisible: false, //交易对弹框
                pairOptions: [], //交易对弹框
                newsDialogVisible: false, //文章弹框
                articleData: { //文章数据
                    cover: "",
                    auther: "",
                    url: "",
                    title: ""
                },
                productDialogTitle: "", //产品弹框标题
                productDialogVisible: false,
                productId: "",
                productType: "",
                productOptions: [],
                quotationDialogVisible: false,  //行情弹框
                quotationData: {
                    pair: "",
                    coverUrl: ""
                },
                options: [], //栏目对应的级联数据
                columnObj: [], //选中的栏目id
                dynamicTags: [], //选择的标签id
                dynamicTagsObj: [], //选择的标签对象
                activeName: "PRODUCT_LABEL", //激活的tab
                dialogVisible: false,  //弹框是否显示
                labelListDialog: [], //对话框选择标签数据列表
                queryLabel: { //对话框查询参数
                    labelName: "",
                    labelType: "",
                    page: 1,
                    size: 1000
                },
                recommend: false, //是否推荐
                topping: false, //是否置顶
                timing: false, //是否定时发布
                wsUri: WSPREVIEW + "/preview?id=",
                previewUri: HTTPPREVIEW + "/cms/news/app/preview.html",
                previewId: userInfoHelper.get().userName,
                websocket: null,
                imageUrls: [],
                tradePair: [],
                labelArry: LABELTYPE
            }
        },
        computed: {
            ...mapState('cmsManage', ['languageList', 'query'])
        },
        watch: {
            "newsData.newsTitle": function () {
                this.sendData();
            },
            "newsData.authorName": function () {
                this.sendData();
            },
            "newsData.richText": function () {
                this.sendData();
            }
        },
        filters: {
            formatValue(item) {
                return item.exchangeCoin + '_' + item.anchoredCoin;
            }
        },
        methods: {
            ...mapMutations('cmsManage', ['changeQuery']),
            handleQueryChange(type, value) {
                this.changeQuery({
                    ...this.query,
                    [type]: value
                });
                this.newsData.lang = value;
                this.getColumnList(-1, 1);
            },
            sendData() {
                if (this.websocket.readyState == 3) {
                    this.$message.success('socket连接已断开！');
                    return;
                }
                this.websocket.send(JSON.stringify({
                    newsTitle: this.newsData.newsTitle,
                    authorName: this.newsData.authorName,
                    publishTime: moment((new Date()).getTime()).format("YYYY-MM-DD HH:mm:ss"),
                    richText: this.newsData.richText
                }));
            },
            saveNews() {
                this.newsData.userName = userInfoHelper.get().userName;
                if (this.newsData.lang == "") {
                    this.$message.success('请选择语言类型！');
                    return;
                }
                if (this.newsData.newsTitle == "") {
                    this.$message.success('标题不能为空！');
                    return;
                }
                if (this.columnObj.length == 0 || this.columnObj[0] == undefined || this.columnObj[0] == "") {
                    this.$message.success('请设置栏目！');
                    return;
                }
                if (this.dynamicTags.length == 0) {
                    this.$message.success('请设置标签！');
                    return;
                }
                if (this.timing && (this.newsData.publishTime.length == 0 || this.newsData.publishTime.length == "")) {
                    this.$message.success('请设置发布时间！');
                    return;
                }
                this.newsData.labelIds = this.dynamicTags.join(",");
                this.newsData.columnId = this.columnObj[this.columnObj.length - 1];
                this.newsData.columnIds = this.columnObj.join(",");
                this.newsData.tradePair = this.tradePair.join(",");
                this.newsData.imageUrls = this.imageUrls.join(",");
                this.newsData.recommend = this.recommend ? "YES" : "NO";
                this.newsData.topping = this.topping ? "YES" : "NO",
                    this.newsData.timer = this.timing ? "YES" : "NO";
                this.$confirm('确认提交吗？提交后将直接发布！', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.publishNewsSimplify(this.newsData).then(({data}) => {
                        this.$message.success('发布成功！');
                    });
                }).catch(() => {
                });
            },
            handleFormChangeContent(val) {
                this.newsData.richText = val;
                this.getImgSrc(val);
            },
            getImgSrc(html) {
                let tem;
                const reg = /<img.+?src=('|")?([^'"]+)('|")?(?:\s+|>)/gim;
                this.imageUrls = [];
                while (tem = reg.exec(html)) {
                    this.imageUrls.push(tem[2]);
                }
            },
            getSucessInfo(data) {
                //上传成功
                this.newsData.coverUrl = data;
            },
            getArticleSucessInfo(data) {
                //上传成功
                this.articleData.cover = data;
            },
            getQuotationSucessInfo(data) {
                //上传成功
                this.quotationData.coverUrl = data;
            },
            insertCard(type) {
                switch (type) {
                    case 'PRODUCT':  //产品
                        let id = "/cms/cms/news/productCard.html?id=" + this.productId + "&lang=" + this.newsData.lang;
                        // this.newsData.richText += '<iframe src="' + id + '" height="100%" width="100%" scrolling="no" frameborder="0"></iframe>';
                        this.$refs.uediter.insertDefineHtml('<iframe src="' + id + '" height="100%" width="100%" scrolling="no" frameborder="0"></iframe>');
                        this.productDialogVisible = false;
                        break;
                    case 'ARTICLECARD':  //文章
                        if (this.articleData.cover == "") {
                            this.$message.success('请上传封面！');
                            return;
                        }
                        if (this.articleData.title == "") {
                            this.$message.success('请输入标题！');
                            return;
                        }
                        if (this.articleData.auther == "") {
                            this.$message.success('请输入作者！');
                            return;
                        }
                        if (this.articleData.url == "") {
                            this.$message.success('请输入文章链接！');
                            return;
                        }
                        let articleCardUrl = "/cms/cms/news/articleCard.html?cover=" + encodeURIComponent(this.articleData.cover) + "&auther=" + encodeURIComponent(this.articleData.auther) + "&url=" + encodeURIComponent(this.articleData.url) + "&title=" + encodeURIComponent(this.articleData.title);
                        // this.newsData.richText += '<iframe src="' + articleCardUrl + '" height="100%" width="100%" scrolling="no" frameborder="0"></iframe>';
                        this.$refs.uediter.insertDefineHtml('<iframe src="' + articleCardUrl + '" height="100%" width="100%" scrolling="no" frameborder="0"></iframe>');
                        this.newsDialogVisible = false;
                        break;
                    case 'PAIRCARD':  //交易对
                        if (this.pair == "") {
                            this.$message.success('请选择交易对！');
                            return;
                        }
                        let pairCardUrl = "/cms/cms/news/pairCard.html?pair=" + this.pair;
                        // this.newsData.richText += '<iframe src="' + pairCardUrl + '" height="50px" width="100%" scrolling="no" frameborder="0"></iframe>';
                        this.$refs.uediter.insertDefineHtml('<iframe src="' + pairCardUrl + '" height="50px" width="100%" scrolling="no" frameborder="0"></iframe>');
                        if (this.tradePair.indexOf(this.pair) == -1) {
                            this.tradePair.push(this.pair);
                        }
                        this.pairDialogVisible = false;
                        break;
                    case 'QUOTATIONCARD':  //行情
                        if (this.quotationData.pair == "") {
                            this.$message.success('请选择交易对！');
                            return;
                        }
                        if (this.quotationData.coverUrl == "") {
                            this.$message.success('请上传封面！');
                            return;
                        }
                        let quotationCardUrl = "/cms/cms/news/quotationCard.html?pair=" + this.quotationData.pair + "&coverUrl=" + encodeURIComponent(this.quotationData.coverUrl);
                        // this.newsData.richText += '<iframe src="' + quotationCardUrl + '" height="395.6px" width="100%" scrolling="no" frameborder="0"></iframe>';
                        this.$refs.uediter.insertDefineHtml('<iframe src="' + quotationCardUrl + '" height="395.6px" width="100%" scrolling="no" frameborder="0"></iframe>');
                        this.quotationDialogVisible = false;
                        break;
                }
            },
            openPairDialog() {
                api.getAllSupportingPairs().then(({data}) => {
                    this.pairOptions = data;
                });
                this.pairDialogVisible = true;
            },
            quotationDialog() {
                api.getAllSupportingPairs().then(({data}) => {
                    this.pairOptions = data;
                });
                this.quotationDialogVisible = true;
            },
            openProductDialog(type) {
                if (this.newsData.lang == null || this.newsData.lang == "") {
                    this.$message.info('请先选择语言！');
                    return;
                }
                let param = "";
                if (type == 'PERIODICAL') {
                    this.productDialogTitle = "插入定期宝";
                    param = "3";
                } else if (type == 'CURRENT') {
                    this.productDialogTitle = "插入活期宝";
                    param = "2";
                }
                this.productType = type;
                api.getFinancialList({type: param}).then(({data}) => {
                    this.productOptions = data;
                });
                this.productDialogVisible = true;
            },
            clearData() {
                this.$refs.articleUpload.handleRemove();
                this.articleData = { //文章数据
                    cover: "",
                    auther: "",
                    url: "",
                    title: ""
                }
            },
            clearDataTwo() {
                this.productId = "";
                this.pair = "";
            },
            clearDataThree() {
                this.$refs.quotationUpload.handleRemove();
                this.quotationData = { //行情数据
                    coverUrl: "",
                    pair: "",
                }
            },
            handleItemChange(val) {
                this.columnObj = val;
                this.getColumnList(val[val.length - 1]);
            },
            getColumnList(parentId, columnLevel) {
                if (this.newsData.lang == null || this.newsData.lang == "") {
                    this.$message.info('请先选择语言！');
                    return;
                }
                let queryColumn = { //查询参数
                    columnName: "",
                    parentId: parentId,
                    columnLevel: columnLevel,
                    lang: this.newsData.lang,
                    page: 1,
                    size: 1000
                };
                api.getColumnList(queryColumn).then(({data}) => {
                    if (columnLevel == 1) {
                        this.options = [];
                        data.records.forEach(item => {
                            if (item.columnType != "RECOMMEND" && item.columnType != "NEWS") {
                                let child = {value: item.id + "", label: item.columnName, children: []}
                                this.options.push(child);
                                this.getColumnList(item.id);
                            }
                        });
                    } else {
                        this.formatColumnData(parentId, data.records, this.options);
                    }
                });
            },
            formatColumnData(parentId, records, source) {
                if (source.length <= 0) {
                    return;
                }
                for (let i = 0; i < source.length; i++) {
                    if (parentId == source[i].value) {
                        source[i].children = [];
                        records.forEach(a => {
                            if (a.columnType != "RECOMMEND" && a.columnType != "NEWS") {
                                let child = {value: a.id + "", label: a.columnName, children: []}
                                source[i].children.push(child);
                            }
                        });
                        return;
                    } else {
                        this.formatColumnData(parentId, records, source[i].children);
                    }
                }
            },
            handleLabelClick() {
                this.queryLabel.labelName = "";
                this.queryLabel.labelType = this.activeName;
                this.getDialogLabelList(this.queryLabel);
            },
            getDialogLabelList(query) {
                api.getLabelList(query).then(({data}) => {
                    this.labelListDialog = data.records;
                });
            },
            searchDialogLabel() {
                this.queryLabel.labelType = this.activeName;
                this.getDialogLabelList(this.queryLabel);
            },
            handleClose(tag) {
                this.dynamicTags.splice(this.dynamicTags.indexOf(tag.id + ""), 1);
                for (let i = 0; i < this.dynamicTagsObj.length; i++) {
                    if (this.dynamicTagsObj[i].id == tag.id) {
                        this.dynamicTagsObj.splice(i, 1);
                        break;
                    }
                }
            },
            handlePairClose(pair) {
                this.tradePair.splice(this.tradePair.indexOf(pair), 1);
            },
            handleImgClose(img) {
                this.imageUrls.splice(this.imageUrls.indexOf(img), 1);
            },
            getTagType(id) {
                id = id + "";
                return this.dynamicTags.indexOf(id) == -1 ? "info" : "danger";
            },
            chooseLabel(item) {
                let id = item.id + "";
                this.dynamicTags.indexOf(id) == -1 ? this.dynamicTags.push(id) : this.dynamicTags.splice(this.dynamicTags.indexOf(id), 1);
                for (let i = 0; i < this.dynamicTagsObj.length; i++) {
                    if (this.dynamicTagsObj[i].id == id) {
                        this.dynamicTagsObj.splice(i, 1);
                        return;
                    }
                }
                this.dynamicTagsObj.push(item)
            },
            openChooseLabelDialog() {
                this.queryLabel.labelName = "";
                this.queryLabel.labelType = this.activeName;
                this.getDialogLabelList(this.queryLabel);
                this.dialogVisible = true;
            },
            getNewsDetail(id) {
                if (id == null || id == "") {
                    return
                }
                api.getNewsDetail({newsId: id}).then(({data}) => {
                    this.newsData = {
                        modelType: data.modelType,
                        newsTitle: data.newsTitle,
                        newsSubtitle: data.newsSubtitle,
                        authorName: data.authorName,
                        coverUrl: data.coverUrl,
                        richText: data.richText,
                        lang: data.language,
                        newsType: "ARTICLE",
                        newsId: id,
                        columnId: data.columnId,
                        columnIds: data.columnIds,
                        recommend: data.recommend == 0 ? "YES" : "NO",
                        topping: data.topping == 0 ? "YES" : "NO",
                        timer: "NO",
                        imageUrls: data.imageUrls,
                        tradePair: data.tradePair,
                        grade: data.grade == 1 ? "ONE" : "TWO",
                        publishTime: data.publishTime,
                        userName: userInfoHelper.get().userName
                    };
                    this.recommend = data.recommend == 0 ? true : false;
                    this.topping = data.topping == 0 ? true : false;
                    this.changeQuery({
                        ...this.query,
                        ['language']: data.language
                    });
                    this.dynamicTags = [];
                    this.dynamicTagsObj = data.labelDetails;
                    if (data.columnDetail) {
                        this.columnObj = data.columnIds.split(',');
                    } else {
                        this.columnObj = [];
                    }
                    this.dynamicTagsObj.forEach(item => {
                        this.dynamicTags.push(item.id + "");
                    });
                    this.imageUrls = data.imageUrls.split(",");
                    this.tradePair = data.tradePair.split(",");
                    this.tradePair= this.tradePair.filter((x) => x !== '');
                    //获取栏目数据
                    this.getColumnList(-1, 1);
                });
            },
            previewWebSocket() {
                let _othis = this;
                this.websocket = new WebSocket(this.wsUri + this.previewId);
                this.websocket.onopen = function (evt) {
                    _othis.$message.success('socket连接成功！');
                };
                this.websocket.onclose = function (evt) {
                    _othis.$message.success('socket连接已断开！');
                };
                this.websocket.onmessage = function (evt) {

                };
                this.websocket.onerror = function (evt) {
                    _othis.$message.success('socket连接错误！');
                };
            },
            qrCode() {
                let _othis = this;
                console.log(_othis.previewUri + "?id=" + _othis.previewId + "&newsTitle=" + _othis.newsData.newsTitle + "&authorName=" + _othis.newsData.authorName + "&publishTime=" + _othis.newsData.publishTime)
                this.$nextTick(function () {
                    document.getElementById("qrcode").innerHTML = "";
                    let qrcode = new QRCode("qrcode", {
                        width: 150,
                        height: 150,
                        text: _othis.previewUri + "?id=" + _othis.previewId,
                        colorDark: "#000000",
                        colorLight: "#d9d9d9"
                    });
                });
            },
            connectSocket() {
                this.websocket.close();
                this.previewWebSocket();
            }
        },
        created() {
            //获取页面详情
            //获取栏目数据
            this.getColumnList(-1, 1);
            this.getNewsDetail(this.$route.query.id);
            this.previewWebSocket();
            console.log(process.env.NODE_ENV)
        },
        beforeDestroy() {
            this.websocket.close();
        }
    }
</script>

<style type="text/css">
    html, body {
        font-size: 10px;
    }

    .artile .news-info-box .el-input__inner {
        border: 0px
    }

    .left-detail-box .detail * {
        margin-top: 0px;
    }
</style>
<style lang="less" scoped>
    .artile {
        min-width: 1500px;
        .news-info-item {
            padding-top: 20px;
            padding-bottom: 20px;
            width: 95%;
            margin: auto;
            .title {
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: rgba(51, 51, 51, 1);
                letter-spacing: 10px;
            }
        }

        .model-box {
            background-color: #FFFFFF;

            .news-info-item {
                border-bottom: 1px solid rgba(54, 67, 101, 0.09803921568627452);
                padding-top: 20px;
                padding-bottom: 20px;
                width: 95%;
                margin: auto;
                .title {
                    font-size: 16px;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    color: rgba(51, 51, 51, 1);
                    letter-spacing: 10px;
                }
            }
        }

        .news-info-box {
            background-color: #FFFFFF;
            margin-top: 30px;

            .news-info-item {
                border-bottom: 1px solid rgba(54, 67, 101, 0.09803921568627452);
                padding-top: 20px;
                padding-bottom: 20px;
                width: 95%;
                margin: auto;
                .title {
                    font-size: 16px;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    color: rgba(51, 51, 51, 1);
                    letter-spacing: 10px;
                }

                .left-detail-box {
                    font-size: 20px;
                    float: right;
                    height: 1029px;
                    width: 676px;
                    display: inline-block;
                    background-color: #FFFFFF;
                    border: 1px solid gray;
                    overflow-y: auto;

                    .title {
                        width: 100%;
                        text-align: center;
                        font-size: 100%;
                        font-family: Microsoft YaHei;
                        font-weight: bold;
                        color: rgba(51, 51, 51, 1);
                        letter-spacing: 5px;
                        margin-top: 30px;
                    }
                    .author {
                        font-size: 70%;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: rgba(51, 51, 51, 1);
                        letter-spacing: 3px;
                        text-align: center;
                        margin-top: 20px;
                    }
                    .time {
                        font-size: 70%;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: rgba(172, 172, 172, 1);
                        letter-spacing: 2px;
                        margin-top: 20px;
                        text-align: center;
                    }
                    .content {
                        width: 95%;
                        margin: auto;
                        margin-top: 20px;

                        .abstract {
                            font-size: 80%;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            line-height: 1.5;
                            color: rgba(141, 141, 141, 1);
                        }

                        .detail {
                            font-size: 16px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            line-height: 1.75;
                            color: rgba(51, 51, 51, 1);
                            margin-top: 30px;
                        }
                    }

                }
            }

            .news-info-buttom {
                text-align: center;
                margin: 50px 0px;
                height: 70px;
            }
        }
    }
</style>